export default __webpack_public_path__ + "static/media/lpimage2.f27d036d.jpg";